import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import Carousel from '@homeaway/react-carousel';
import {pushEdapEvent} from '../../../utils/edap';
import {getPrefix} from '../../../utils/urls';
import {CarouselCard} from '../carousel-card/CarouselCard';

const MESSAGE_KEYS = {
    title: 'module.linkpile.city.descendants.title',
    cardHeading: 'module.linkpile.city.descendants.card.heading',
    cardSubheading: 'module.linkpile.city.descendants.card.subheading'
};

function messageForTitle({formatMessage}, simpleName) {
    return formatMessage(
        {id: MESSAGE_KEYS.title},
        {simpleDestinationName: simpleName}
    );
}

function messageForCardHeading({formatMessage}, simpleName) {
    return formatMessage(
        {id: MESSAGE_KEYS.cardHeading},
        {simpleDestinationName: simpleName}
    );
}

function messageForCardSubHeading({formatMessage, formatNumber}, count) {
    return formatMessage(
        {id: MESSAGE_KEYS.cardSubheading},
        {listingCount: formatNumber(count || 0)}
    );
}

function edapClickHandler(lbsId) {
    const eventData = {
        actionlocation: 'city-descendant-linkpile',
        eventlbsuuid: lbsId,
        eventRefinements: 'locality'
    };

    return () => pushEdapEvent(
        'destination.link.click',
        eventData,
        {delayProcessing: true}
    );
}

function replaceTemplateString(template, res) {
    return (template || '').replace('${templateId}', `carousel-${res}`);
}

function createCard(intl, payload, mounted) {
    return ({simpleName, fullName, url, lbsId, propertyCount}, index) => {
        const title = messageForCardHeading(intl, simpleName);
        const footer = messageForCardSubHeading(intl, propertyCount);
        const data = payload.find((p) => p.key === lbsId) || {};
        const mkSrc = replaceTemplateString.bind(null, data.urlTemplate);

        if (data.urlTemplate || !mounted) {
            return (
                <CarouselCard
                    key={index}
                    baseClass={'full-image-card'}
                    mkSrc={mkSrc}
                    path={url}
                    linkRel={null}
                    title={title}
                    subtitle={''}
                    fullName={fullName}
                    footer={footer}
                    onClick={edapClickHandler(lbsId)}
                />
            );
        }

        return null;
    };
}

export class PopularDestinationsComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            payload: []
        };
    }

    componentDidMount() {
        const {popularDestinations} = this.props;

        if (popularDestinations.length) {
            const lbsIds = popularDestinations.map((p) => p.lbsId).join(',');
            fetch(`/${getPrefix()}/api/images?ids=${lbsIds}`, {
                credentials: 'same-origin'
            })
                .then((response) => response.json())
                .then((payload) => {
                    if (payload && Array.isArray(payload)) {
                        // TODO: how do we log errors here?
                        this.setState({mounted: true, payload});
                    }
                });
        }
    }

    render() {
        const {popularDestinations, simpleName, intl} = this.props;
        const {payload, mounted} = this.state;

        if (popularDestinations.length < 3) {
            return null;
        }

        const cards = popularDestinations
            .map(createCard(intl, payload, mounted))
            .filter((x) => !!x)
            .slice(0, 6);

        if (cards.length < 3) {
            return null;
        }

        const titleMessage = messageForTitle(intl, simpleName);

        return (
            <div className="container popular-destinations">
                <h2 className="popular-destinations__title">
                    {titleMessage}
                </h2>
                <Carousel className="popular-destinations__carousel" pageSize={2}>
                    {cards}
                </Carousel>
            </div>
        );
    }
}

export function mapStateToProps({destination}) {
    const {locality, details} = destination;

    return {
        popularDestinations: locality || [],
        simpleName: (details && details.simpleName) || ''
    };
}

export const PopularDestinations = injectIntl(
    connect(mapStateToProps)(PopularDestinationsComponent)
);
